"use client";

export default function LogoutButton() {
  async function handleLogout() {
    await fetch("/api/auth/logout", { method: "POST" });
    window.location.href = "/login";
  }

  return (
    <button onClick={handleLogout} className="btn-glass" style={{ padding: "6px 14px", fontSize: "13px" }}>
      Sign out
    </button>
  );
}
